module.exports = __webpack_public_path__ + "img/interested_element.688aebc3.png";